var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"issue-box",class:{'selected': _vm.isSelected}},[_c('p',{staticClass:"type"},[_vm._v(_vm._s(_vm.isOld ? 'old' : 'new'))]),_c('p',{staticClass:"key"},[_vm._v(_vm._s(_vm.formattedData))])])}
var staticRenderFns = []

export { render, staticRenderFns }